module.exports = __webpack_public_path__ + "img/image_middle_empty_d@2x.1c9159e9.png";